// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Adicionar suas próprias opções',
    allActivities: 'Atividade (tarefa, questão, solicitação)',
    AllActivities_group_title: 'Campos de atividade (tarefa, questão, solicitação)',
    batch_mark_as_optional: 'Marcar como opcional',
    batch_mark_as_required: 'Marcar como obrigatório',
    boolean_field_type: 'Caixa de seleção (sim/não)',
    create_cf: 'Criar campo personalizado',
    custom_field_could_not_be_deleted: 'O campo personalizado \"{0}\" não pode ser excluído',
    custom_field_could_not_be_removed: 'O campo personalizado \"{0}\" não pode ser removido',
    custom_field_readonly_warning: 'Você só pode visualizar este campo personalizado com seu nível de acesso. Para fazer alterações, entre em contato com o administrador.',
    customer: 'Cliente',
    Customer_group_title: 'Campos do cliente',
    default_field_name: 'Novo campo',
    delete_field_title: 'Excluir o campo \"{0}\"?',
    everywhere: 'Em todos os lugares',
    expense: 'Despesa',
    Expense_group_title: 'Campos de despesa',
    field_is_used_in_formula: '1#Este campo personalizado é usado no campo de fórmula personalizada {0}#Este campo personalizado é usado em {0} campos de fórmula personalizados',
    field_non_editable_portfolio_restriction: 'Este campo personalizado não pertence a projetos no portfólio <b>{0}</b>',
    field_non_editable_without_portfolio_restriction: 'Este campo personalizado não pertence a projetos <b>{0} sem portfólio</b>',
    field_non_editable_wrong_space: 'Este campo personalizado não pertence ao espaço <b>{0}</b>',
    fields_plural: '1#{0} campo#{0} campos',
    formula_description: 'Para a criação de fórmulas, você pode usar os tipos de campo Número, Dinheiro e Horas e as operações + - * /. Você também pode adicionar parênteses para criar fórmulas compostas:',
    formula_example: 'Por exemplo:',
    formula_field_type: 'Fórmula',
    hyperlink_field_type: 'Hiperlink',
    issue: 'Questão',
    Issue_group_title: 'Campos de questão',
    limitReachedMessage: 'Desculpe, você atingiu o número máximo de campos personalizados do tipo escolhido que pode adicionar.',
    mark_as_optional_feedback: '1#O campo personalizado {0} foi marcado como opcional com sucesso#{0} campos personalizados foram marcados como opcionais com sucesso',
    mark_as_optional_feedback_failure: '1#O campo personalizado {0} não pôde ser marcado como opcional devido ao seu tipo (lista suspensa, fórmula, ou caixa de seleção)#{0} campos personalizados não puderam ser marcados como opcionais devido aos seus tipos (lista suspensa, fórmula, ou caixa de seleção)',
    mark_as_required_feedback: '1#O campo personalizado {0} foi marcado como obrigatório com sucesso#{0} campos personalizados foram marcados como obrigatórios com sucesso',
    mark_as_required_feedback_failure: '1#O campo personalizado {0} não pôde ser marcado como obrigatório devido ao seu tipo (lista suspensa, fórmula, ou caixa de seleção)#{0} campos personalizados não puderam ser marcados como obrigatórios devido aos seus tipos (lista suspensa, fórmula, ou caixa de seleção)',
    msg_deleteUsedValue: 'Este valor é usado em {0} {1}',
    msg_entities_portfolioRemoved: 'Este campo não estará mais disponível para as entidades incluídas nos portfólios excluídos.',
    msg_entities_spaceRemoved: 'Este campo não estará mais disponível para as entidades incluídas nos espaços excluídos.',
    msg_lead_to: 'Você deseja salvar as alterações?',
    msg_restrictionsAdded: 'Este campo personalizado será restrito ao portfólio.',
    msg_restrictionsRemoved: 'Este campo não será mais restrito ao portfólio.',
    msg_unportfolioedOff: 'Este campo não estará disponível para projetos não incluídos em portfólios.',
    msg_valueRemoved: 'Qualquer item excluído da lista será deletado permanentemente.',
    no_portfolio: 'Sem portfólio',
    nowhere: 'Em nenhum lugar',
    numeric_field_type: 'Número',
    other_portfolios: 'Outros portfólios',
    portfolio: 'Portfólio',
    Portfolio_group_title: 'Campos do portfólio',
    project: 'Projeto',
    Project_group_title: 'Campos do projeto',
    readonly_warning_no_access_to_portfolios: 'Você só pode visualizar este campo personalizado porque está associado a portfólios aos quais você não tem acesso.',
    remove_field_description: 'O campo personalizado ainda estará disponível nas configurações da empresa.',
    remove_field_title: 'Você deseja remover o campo personalizado \"{0}\" de \"{1}\"?',
    request: 'Solicitação',
    Request_group_title: 'Campos de solicitação',
    required_fileds_not_filled: '1#O campo obrigatório {0} não foi preenchido#{0} campos obrigatórios não foram preenchidos',
    select_from: 'Selecionar campo personalizado',
    spaces_field_label: 'Espaços',
    spaces_field_section_title: 'Disponível nos espaços',
    task: 'Tarefa',
    Task_group_title: 'Campos de tarefa',
    text_add: 'Adicionar',
    text_add_new_item: 'Adicionar um novo item ou usar Ctrl+V para colar uma lista de itens',
    text_add_portfolio: 'Adicionar portfólio',
    text_addDescription: 'Adicionar descrição',
    text_all_objects: 'Todos os objetos',
    text_available_in: 'Portfólios para o campo',
    text_create_new_field: 'Adicionar campo personalizado',
    text_currentIdentity: 'Começar de',
    text_custom_field_for: 'Campo para',
    text_delete: 'Excluir campo',
    text_delete_permanently: 'Excluir permanentemente',
    text_deleteValue: 'Excluir valor',
    text_edit: 'Editar campo',
    text_empty_page_part1: 'Você precisa de mais flexibilidade para rastrear e relatar seus dados?',
    text_empty_page_part2: 'Adicione seus próprios campos para projetos, tarefas, usuários e muito mais...',
    text_error_title: 'A operação não pôde ser concluída.',
    text_field_type: 'Texto',
    text_fieldName: 'Nome do campo',
    text_fieldType: 'Tipo de campo',
    text_filter: 'Campos personalizados para',
    text_include_in_unportfolioed_projects: 'Também mostrar para projetos não incluídos em portfólios',
    text_isIdentity: 'Incremento automático',
    text_isNumeric: 'Não mostrar decimais',
    text_isRequired: 'Obrigatório',
    text_place_plural: '1#local#locais',
    text_remainingValuesTemplate: 'mostrar \"{0}\" itens ocultos no topo da lista',
    text_remove: 'Excluir',
    text_restricted_by_portfolio: 'Restrito por portfólio',
    text_set_restrictions: 'Mostrar este campo apenas para projetos incluídos nos portfólios selecionados',
    textarearich_field_type: 'Texto do parágrafo (formatação rica)',
    timeEntry: 'Entrada de tempo',
    TimeEntry_group_title: 'Campos de entrada de tempo',
    tooltip_disable_batch: 'Você só pode visualizar o campo personalizado com seu nível de acesso. Para fazer alterações, entre em contato com o administrador.',
    tooltip_everywhere: '<b>Em todos os lugares</b> - o campo personalizado não possui restrições de visibilidade.',
    tooltip_nowhere: '<b>Em nenhum lugar</b> - o campo personalizado não está incluído em nenhum lugar.',
    tooltip_other_portfolios: '<b>Outros portfólios</b> - refere-se a portfólios para os quais você não tem as permissões necessárias para acessar.',
    tooltip_portfolio_and_without_part1: '<b>Nome do portfólio, </b>',
    tooltip_portfolio_and_without_part2: '<b>Sem portfólio</b> - o campo personalizado está incluído em entidades nos portfólios selecionados e entidades sem portfólios.',
    tooltip_portfolio_name: '<b>Nome do portfólio</b> - o campo personalizado está incluído nos portfólios selecionados.',
    tooltip_without_portfolio: '<b>Sem portfólio</b> - o campo personalizado está incluído em entidades sem portfólios.',
    unknown_portfolio_description: 'Refere-se a portfólios para os quais você não tem as permissões necessárias para acessar.',
    upgradeToEnterpriseMessage: 'Você atingiu o limite da Edição Equipe. Por favor, <a href=\"{licenseUrl}\" target=\"_blank\">atualize</a> para {brandName} Edição Empresarial.',
    use_cfs_options: 'Usar campo personalizado como fonte de opções',
    use_own_options: 'Usar suas próprias opções',
    user: 'Usuário',
    User_group_title: 'Campos de usuário',
    validation_error_InvalidBracketsNumber: 'Uso inválido de parênteses',
    validation_error_InvalidField: 'Entrada de campo inválida. O campo \"{0}\" não existe',
    validation_error_InvalidOperation: 'Uso inválido de operações matemáticas. Apenas os operadores ‘+’, ‘-’, ‘*’ e ‘/’ são permitidos',
    validation_error_InvalidSymbol: 'Uso inválido de símbolos',
    validation_error_MismatchedInput: 'Fórmula incompleta. Garanta que todos os símbolos e operadores sejam fornecidos para criar uma fórmula válida',
    validation_error_Unknown: 'Formato de fórmula inválida',
    visibility_title: 'Visibilidade',
    warning_linked_global_field_activities: 'As alterações nesse campo personalizado afetarão atividades em vários espaços.',
    warning_linked_global_field_expenses: 'As alterações nesse campo personalizado afetarão despesas em vários espaços.',
    warning_linked_global_field_projects: 'As alterações nesse campo personalizado afetarão projetos em vários espaços.',
    warning_linked_global_field_time: 'As alterações nesse campo personalizado afetarão entradas de tempo em vários espaços.',
    warning_wont_visible_without_space: 'O campo personalizado não será visível para os usuários até ser adicionado ao espaço.',
};
